import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function FwfLogo({ label = "Freshwater Futures", size, className, ...rest }) {
    return (_jsx("span", { className: cn("fwfa-fwf-logo", size && `fwfa-fwf-logo--${size}`, className), role: "img", "aria-label": label, ...rest }));
}
//# sourceMappingURL=FwfLogo.js.map